import angular from 'angular';
import booksService from '../../util/BooksSvc/BooksSvc';
// TODO commonweb
import transactionDetailTemplate from './transactionDetail.template.html';

export default angular
  .module('books.ui.transactionDetail', ['CSMCommonWeb', booksService])
  .directive('transactionDetail', transactionDetailDirective).name;

/*******************************************************************************
 * Directive
 *******************************************************************************/
function transactionDetailDirective() {
  return {
    template: transactionDetailTemplate,
    controller: controller,
    controllerAs: '$ctrl',
    scope: {
      acctSin: '@', // Label for type of report in singular format
      acctPl: '@', // Label for type of report in plural format
      accountTypeHide: '@', // Hides the Account Types div when true.
      catName: '=', // Variable name of the accountName in the accountsList array
      fundraiserLabel: '@', // Variable name for the fundraisers selection label
      fundName: '=', // Variable name of the name in the fundraisersList array
      transactionList: '=' // List of transactions types to choose from. PTA/Booster are different from ASB.
    }
  };
}

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function controller($injector, $scope) {
  const $svcs = { $ctrl: this, $injector, $scope };

  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
}

/*******************************************************************************
 * $onInit */
/**
 * Initializes the controller by loading organization data, fundraisers, account types, and chart of accounts.
 * Also sets the default form options on page load.
 *******************************************************************************/
/* @ngInject */ function onInit($ctrl, BooksSvc, BusyScreen) {
  return function () {
    $ctrl.req.activeTransaction = $ctrl.transactionList[0];

    BusyScreen.promise(
      BooksSvc.getClassInfoList(NaN, true).then(function (resp) {
        resp.data.sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        $ctrl.fundraisersList = [{ id: NaN, name: $ctrl.fundName }].concat(
          resp.data
        );

        BooksSvc.viewAccountTypes().then(function (resp) {
          resp.data.sort(function (a, b) {
            return a.type.toLowerCase().localeCompare(b.type.toLowerCase());
          });
          $ctrl.accountTypeList = [
            { type: '', label: 'All Account Types' }
          ].concat(
            resp.data.map(function (at) {
              at.label = at.type;
              return at;
            })
          );

          BooksSvc.viewChartOfAccounts().then(function (resp) {
            resp.data.sort(function (a, b) {
              return a.accountName
                .toLowerCase()
                .localeCompare(b.accountName.toLowerCase());
            });
            $ctrl.accountsList = [
              { accountID: NaN, accountName: $ctrl.catName }
            ].concat(resp.data);

            BooksSvc.getOrganization().then(function (resp) {
              $ctrl.org = resp.data;
            });

            /*--------------------------------------------*/
            /* Sets the default form options on page load */
            /*--------------------------------------------*/
            $ctrl.resetFilters();
          });
        });
      })
    );
  };
}

/*****************************************************************************
 * amountCheck */
/**
 * Fired when amount radio buttons change value. Enables and disables additional
 * amount radio buttons and clears the amount values when the "All" radio button
 * is clicked.
 *****************************************************************************/
/* @ngInject */ function amountCheck($ctrl) {
  return function () {
    $ctrl.disableAdditionalOptions =
      ['>', '>='].indexOf($ctrl.req.requireAmtStart) == -1;
    if ($ctrl.req.requireAmtStart == '') {
      $ctrl.req.amountValue = 0;
      $ctrl.req.additionalAmountValue = 0;
      $ctrl.req.enableAmtEnd = false;
      $ctrl.req.additionalAmount = '';
    }
  };
}

/*****************************************************************************
 * checkTransNumber */
/**
 * Clears the transaction number if the transaction selection changes to something
 * that does not allow for a specific document number search.
 *****************************************************************************/
/* @ngInject */ function checkTransNumber($ctrl) {
  return function () {
    if (!$ctrl.req.activeTransaction.docnum) $ctrl.req.transactionValue = '';
  };
}

/*****************************************************************************
 * createReport */
/**
 * Creates the report with the following parameters.
 *****************************************************************************/
/* @ngInject */ function createReport($ctrl) {
  return function () {
    /*------------------------------------------------*/
    /* Works with the CSMValidator directive to check */
    /* there are values populated in these fields.    */
    /*------------------------------------------------*/
    if (!$ctrl.valOption.validate()) return;

    /*----------------------------------------------------------*/
    /* Allows for the entity name selection to be a string      */
    /* rather than an object property. This allows the user     */
    /* to search for a string that is not in the list of names. */
    /*----------------------------------------------------------*/

    var pageURL =
      `TransactionDetailReport.aspx?` +
      `rt=${$ctrl.req.reportFormat}` +
      `&sd=${getDateParm($ctrl.req.startDate)}` +
      `&ed=${getDateParm($ctrl.req.endDate)}` +
      `&bt=${$ctrl.req.activeTransaction.code}` +
      `&dn=${$ctrl.req.transactionValue ? $ctrl.req.transactionValue : ''}` +
      `&at=${$ctrl.req.type}` +
      `&aid=${$ctrl.req.accountID || ''}` +
      `&cid=${$ctrl.req.classID || ''}` +
      `&et=${$ctrl.req.entityType || ''}` +
      `&eid=${$ctrl.req.entityID || ''}` +
      `&em=` +
      `&sa=${$ctrl.req.requireAmtStart ? $ctrl.req.amountValue : ''}` +
      `&sac=${$ctrl.req.requireAmtStart ? $ctrl.req.requireAmtStart : ''}` +
      `&ea=${$ctrl.req.additionalAmount ? $ctrl.req.additionalAmountValue : ''}` +
      `&eac=${$ctrl.req.additionalAmount ? $ctrl.req.additionalAmount : ''}`;

    window.open(pageURL);
  };
}

/*******************************************************************************
 * getDateParm */
/**
 * Puts the date object in to a string format.
 *
 * @param    date Current date
 * @return       date in string format
 *******************************************************************************/
function getDateParm(date) {
  if (date) {
    const padInt = (num) => ('0' + num).slice(-2);
    const month = padInt(date.getMonth() + 1);
    const day = padInt(date.getDate());
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  return '';
}

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the controller object.
 *******************************************************************************/
/* @ngInject */ function initCtrl($ctrl, $injector, $scope, $svcs) {
  Object.assign($ctrl, {
    acctSin: $scope.acctSin,
    acctPl: $scope.acctPl,
    accountTypeHide: $scope.accountTypeHide,
    catName: $scope.catName,
    fundraiserLabel: $scope.fundraiserLabel,
    fundName: $scope.fundName,
    transactionList: $scope.transactionList,

    /*---------------------------------------------*/
    /* Sets the default report format on page load */
    /*---------------------------------------------*/
    req: {
      endDate: null,
      reportFormat: 'PDF',
      startDate: null,
      transactionValue: '',
      activeTransaction: null,
      accountID: NaN,
      type: '' /* Account Type*/,
      classID: NaN /* Fundraisers */,
      requireAmtStart: '' /* Reset Amount radio button value */,
      amountValue: 0 /* start amount field*/,
      enableAmtEnd: false /* Default additional amount options checkbox value */,
      additionalAmountValue: 0 /* Optional additional amount */
    },

    /*---------------------------------------------------------*/
    /* Control object for resetting the entity to All Entities */
    /*---------------------------------------------------------*/
    resetEntity: {},

    /*--------------------------------------------------------*/
    /* Enable and disable the additional amount options. When */
    /* the greater than or the greater than/equal to are      */
    /* selected, the user can also select less than amounts.  */
    /*--------------------------------------------------------*/
    disableAdditionalOptions: true,

    /*----------------------------------------*/
    /* Validation used with the csm-validator */
    /*----------------------------------------*/
    valOption: {},

    /*----------------------------------------------------------------*/
    /* Array of values for the Amount radio buttons. Display is the   */
    /* text to be displayed and the value is the value of the button. */
    /*----------------------------------------------------------------*/
    radValue: [
      { display: 'All', value: '' },
      { display: '=', value: '=' },
      { display: '<', value: '<' },
      { display: '<=', value: '<=' },
      { display: '>', value: '>' },
      { display: '>=', value: '>=' }
    ],

    /*-----------*/
    /* Functions */
    /*-----------*/
    $onInit: $injector.invoke(onInit, null, $svcs),
    amountCheck: $injector.invoke(amountCheck, null, $svcs),
    checkTransNumber: $injector.invoke(checkTransNumber, null, $svcs),
    createReport: $injector.invoke(createReport, null, $svcs),
    resetFilters: $injector.invoke(resetFilters, null, $svcs)
  });
}

/*****************************************************************************
 * resetFilters */
/**
 * Resets values on button click and sets the values on page load.
 *****************************************************************************/
/* @ngInject */ function resetFilters($ctrl) {
  return function () {
    $ctrl.req.transactionValue = '';
    $ctrl.req.activeTransaction = $ctrl.transactionList[0];
    $ctrl.req.accountID = NaN;
    $ctrl.req.type = '';
    $ctrl.req.classID = NaN;
    $ctrl.req.requireAmtStart = '';
    $ctrl.req.amountValue = 0;
    $ctrl.req.enableAmtEnd = false;
    $ctrl.req.additionalAmountValue = 0;

    /*------------------------------------------*/
    /* Works with the entitySelection directive */
    /* to reset the Entities to "All Entities"   */
    /*------------------------------------------*/
    $ctrl.resetEntity.reset();
    $ctrl.disableAdditionalOptions = true;
  };
}
